import { PaymentTransactionConstants as Constants } from '../types'
import { paymentTransactionApi as api } from '../../api'

export const paymentTransactionActions = {
    get,
    stats,
    export_data,
    clear,
};

function get(offset, data, page_size, totalRecords = 0) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._get(offset, data, page_size, totalRecords)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    }
    function success(payload) { return { type: Constants.GET, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
}

function stats(data) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._stats(data)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    }
    function success(payload) { return { type: Constants.STATS, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
}

function export_data(data) {
    return dispatch => {
        return new Promise((resolve, reject) => {
            api._export_data(data)
                .then(
                    payload => {
                        dispatch(success(payload));
                        resolve(payload)
                    },
                    error => {
                        dispatch(failure(error));
                        reject(error)
                    }
                )
        });
    }
    function success(payload) { return { type: Constants.EXPORT, payload } }
    function failure(error) { return { type: Constants.FAIL, error } }
}

function clear() {
    return dispatch => {   
        return new Promise((resolve, reject) => {     
            dispatch(success());
            resolve()
        })   
    }
    function success() { return { type: Constants.CLEAR } }
}